import { styled } from '@mui/material/styles';
import { Box, TextField, Button, Typography } from '@mui/material';

export const MainContainer = styled(Box)(({ theme }) => ({
  padding: '24px',
  maxWidth: '1200px',
  margin: '0 auto',
  '@media (max-width: 600px)': {
    padding: '12px',
    width: '100%',
    boxSizing: 'border-box'
  },
}));

export const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '24px',
  width: '100%',
  '@media (max-width: 600px)': {
    marginBottom: '16px',
    padding: '0 8px'
  }
});

export const LoadingIndicator = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '200px',
});

export const Form = styled('form')({
  width: '100%',
});

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 500,
  color: theme.palette.text.primary,
  marginBottom: '16px',
  display: 'flex',
  alignItems: 'center',
}));

export const AddressSection = styled(Box)(({ theme }) => ({
  marginTop: '24px',
  padding: '24px',
  backgroundColor: 'rgba(25, 118, 210, 0.02)',
  borderRadius: '12px',
  border: '1px solid rgba(25, 118, 210, 0.1)',
}));

export const AddressTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 500,
  color: theme.palette.text.primary,
  marginBottom: '16px',
  display: 'flex',
  alignItems: 'center',
}));

export const ReadOnlyTextField = styled(TextField)({
  '& .MuiInputBase-input': {
    cursor: 'default',
  },
});

export const ButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '24px',
  gap: '12px',
  '@media (max-width: 600px)': {
    flexDirection: 'column',
    width: '100%',
    gap: '8px',
    marginTop: '12px',
    padding: '0 8px',
    boxSizing: 'border-box'
  },
});

export const SubmitButton = styled(Button)(({ theme }) => ({
  minWidth: '180px',
  height: '48px',
  fontSize: '1rem',
  fontWeight: 500,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
  },
  '@media (max-width: 600px)': {
    minWidth: 'auto',
    width: '100%',
    height: '36px',
    fontSize: '0.875rem',
    padding: '6px 12px',
    margin: '0',
    boxSizing: 'border-box'
  },
}));

export const StatBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '16px',
  backgroundColor: 'rgba(25, 118, 210, 0.04)',
  borderRadius: '8px',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
    transform: 'translateY(-2px)',
  },
}));

export const StatValue = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 600,
  color: theme.palette.primary.main,
  marginBottom: '4px',
}));

export const StatLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
  textAlign: 'center',
}));

export const UploadDocumentCard = styled(Box)(({ theme }) => ({
  padding: '24px',
  borderRadius: '12px',
  background: 'linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, rgba(25, 118, 210, 0.1) 100%)',
  border: '2px dashed rgba(25, 118, 210, 0.2)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: 'linear-gradient(135deg, rgba(25, 118, 210, 0.08) 0%, rgba(25, 118, 210, 0.15) 100%)',
    borderColor: theme.palette.primary.main,
  },
}));

export const TabPanel = styled(Box)({
  padding: '24px 0',
});

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  marginTop: '8px',
  fontSize: '0.875rem',
}));

export const SuccessMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.success.main,
  marginTop: '8px',
  fontSize: '0.875rem',
}));

export const MortgageCard = styled(Box)(({ theme }) => ({
  padding: '24px',
  borderRadius: '12px',
  background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
  color: '#fff',
  marginBottom: '24px',
  boxShadow: '0px 4px 20px rgba(25, 118, 210, 0.2)',
}));

export const MortgageTrackList = styled(Box)({
  marginTop: '24px',
});

export const MortgageTrackItem = styled(Box)(({ theme }) => ({
  padding: '16px',
  borderRadius: '8px',
  backgroundColor: '#fff',
  marginBottom: '12px',
  border: '1px solid #e0e0e0',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
    borderColor: theme.palette.primary.main,
  },
})); 